module.exports = {"421182001":"武穴街道","421182002":"刊江街道","421182003":"田镇街道","421182004":"万丈湖街道","421182100":"梅川镇","421182101":"余川镇","421182102":"花桥镇","421182103":"大金镇","421182104":"石佛寺镇","421182105":"四望镇","421182106":"大法寺镇","421182107":"龙坪镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/421182.json
// module id = 1630
// module chunks = 0